import { useState, useRef, useEffect } from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLeftLong, faRightLong } from '@fortawesome/free-solid-svg-icons';


export default function OurTeam({ content }) {

    const [isVisible, setIsVisible] = useState(false);
    const componentRef = useRef(null);

    useEffect(() => {
        const handleScroll = () => {
            if (componentRef.current) {
                const top = componentRef.current.getBoundingClientRect().top;
                const windowHeight = window.innerHeight;
                if (top < windowHeight) {
                    setIsVisible(true);
                }
            }
        };

        window.addEventListener('scroll', handleScroll);
        handleScroll(); // Check on mount in case the component is already in the viewport

        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    const [scrollPosition, setScrollPosition] = useState(0);
    const sliderRef = useRef(null);

    const scrollLeft = () => {
        if (sliderRef.current) {
            sliderRef.current.scrollBy({ left: -100, behavior: 'smooth' });
        }
    };

    const scrollRight = () => {
        if (sliderRef.current) {
            sliderRef.current.scrollBy({ left: 100, behavior: 'smooth' });
        }
    };

    const handleScroll = () => {
        const position = sliderRef.current.scrollLeft;
        setScrollPosition(position);
    };
    return (
        <div className={`transition-opacity duration-500 ${isVisible ? 'opacity-100' : 'opacity-0'}`} ref={componentRef}>
            <div className="pt-[100px] mb-[80px]">
                <div className="lg:text-6xl md:text-3xl text-xl lg:px-[100px] md:px-[60px] px-[30px] mt-10 mb-20 font-bold text-white">{content.title}</div>
                <div className="relative">
                    <div className="overflow-x-auto whitespace-nowrap" style={{ scrollbarWidth: 'none' }} ref={sliderRef} onScroll={handleScroll}>
                        {content.data.map((item, index) => (
                            <div key={index} className=" group inline-block h-50 w-64 hover:scale-95 transition duration-700 ease-in-out ">
                                <img src={item.img_url} alt={`Slide ${index}`} className="grayscale hover:filter-none" />
                                <div className="group-hover:visible invisible transition ease-in-out duration-700 bg-white text-black">
                                    <div className="text-center font-bold">{item.name}</div>
                                    <div className="text-center text-sm">{item.role}</div>
                                </div>
                            </div>
                        ))}
                    </div>

                    <button className="absolute left-10 top-1/2 transform -translate-y-1/2 bg-yellow-400 px-2 py-1 rounded-full hover:bg-transparent hover:ring-2 ring-yellow-400 ring-inset" onClick={scrollLeft}>
                        <FontAwesomeIcon icon={faLeftLong} style={{ color: "#000000", }} />
                    </button>


                    <button className="absolute right-10 top-1/2 transform -translate-y-1/2 bg-yellow-400 px-2 py-1 rounded-full hover:bg-transparent hover:ring-2 ring-yellow-400 ring-inset" onClick={scrollRight}>
                        <FontAwesomeIcon icon={faRightLong} style={{ color: "#000000", }} />
                    </button>
                </div>
            </div>
        </div>
    );
}